import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import FilterListIcon from '@mui/icons-material/FilterList'
import InsightsIcon from '@mui/icons-material/Insights'
import SearchIcon from '@mui/icons-material/Search'
import { NoticeFeedPage, type NoticeFeedConfig } from './NoticeFeedPage'

const cfg: NoticeFeedConfig = {
    typeint: 2,
    showDeadline: false,
    basePath: '/awardresults',
    noun: 'Contract Awards',
    metaTitle: 'Contract Awards',
    metaDescription: 'Search recent UK & Ireland public sector contract awards. See who won, which buyer awarded and at what value across 200+ procurement portals.',
    keywordMetaDescription: k => `Recent ${k} contract awards across the UK & Ireland public sector. See who is winning, which buyers award and at what value with Contract Finder Pro.`,
    heroHighlight: 'Every Recent',
    heroRest: 'UK & Ireland Public Sector Contract Award',
    heroSub: 'Contract Finder Pro tracks contract awards from every major UK & Ireland public sector portal so you can see who is winning what, from which buyers and at what value',
    searchPlaceholder: 'Search awards by keyword, buyer or supplier…',
    listTitleAll: 'Recent Contract Awards',
    featuresTitle: 'Know Your Market',
    features: [
        {
            Icon: NotificationsActiveIcon,
            title: 'Real-Time Publication',
            body: 'Awards appear on CFP within minutes of being published on Find a Tender, Contracts Finder and 200+ additional portals',
        },
        {
            Icon: InsightsIcon,
            title: 'Competitor Intelligence',
            body: 'See which suppliers win the contracts you care about and benchmark award values across buyers, sectors and regions',
        },
        {
            Icon: FilterListIcon,
            title: 'Buyer Insight',
            body: 'Filter by buyer, category, CPV code, value and region to map who buys what across the public sector before you invest in a bid',
        },
        {
            Icon: SearchIcon,
            title: 'Full Text Search',
            body: 'Search across award titles, buyers, winning suppliers and categories to build a complete picture of your market',
        },
    ],
}

export default function LiveAwards() {
    return <NoticeFeedPage cfg={cfg} />
}
